import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/models/user';
import { HttpService } from '../../assetModule/shared/services/http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WizardService implements OnInit {
  loggendInUser = new User();
  currentTabId = null;
  wizardData = [{
    id: 'searchText',
    componentPath: '/val-assets/home',
    label: 'Search',
    position: 'bottom',
    description: 'Find your 3D assets here with your universal search.'
  }, {
    id: 'search-the-lib',
    componentPath: '/val-assets/search',
    label: 'Asset Category',
    position: 'bottom',
    description: 'Check our content library here organized as per Siemens Business structure.'
  }, {
    id: 'personal-browser',
    componentPath: '/val-assets/personal-browser',
    label: 'Personal Browser',
    position: 'bottom',
    description: 'Organize your uploaded content just a click away.'
  }, {
    id: 'upload-assets',
    componentPath: '/val-assets/upload-new-asset/1',
    label: 'Upload Assets',
    position: 'bottom',
    description: 'Here where you can upload your content from.'
  }, {
    id: 'user_dropdown',
    componentPath: '',
    label: 'User Profile',
    position: 'bottom',
    description: 'Here is where you can personalize your VAL application.'
  }, {
    id: 'newestAssetGrid',
    componentPath: '/val-assets/home',
    label: 'Newest Assets',
    position: 'top',
    description: 'Newest uploaded assets to VAL are shown here.'
  }];

  private _currentWizard = new BehaviorSubject<{}>({});
  readonly currentWizard = this._currentWizard.asObservable();

  currentWizardIndex = 0;

  constructor(private http: HttpClient, private httpService: HttpService) { }

  ngOnInit() {
    if (sessionStorage.getItem('userinfo')) {
      this.loggendInUser = JSON.parse(sessionStorage.getItem('userinfo'));
    }
  }

  createWizard(loggedInUser: User) {
    if ( loggedInUser.wizard === 'Y') {
      sessionStorage.setItem('isWizardClosedTemporarily', 'true');
      console.log('wizard was closed permanently');
    } else {
          console.log('wizard is not closed permanently');
          this.setWizard(0);
      }
    }

  setWizard(index) {
    this._currentWizard.next(this.wizardData[Math.min(index, this.wizardData.length - 1)]);
  }

  isLastWizard () {
    console.log('currentWizardIndex: ', this.currentWizardIndex);
    return this.currentWizardIndex === this.wizardData.length - 1;
  }

  nextWizard() {
    this.currentWizardIndex += 1;
    this._currentWizard
    .next(this.wizardData[Math.min(this.currentWizardIndex, this.wizardData.length - 1)]);
  }

  skipWizard() {
    console.log('skip wizard called');
    console.log(this.wizardData[this.currentWizardIndex + 1].id);
    if (this.wizardData[this.currentWizardIndex + 1].id === 'upload-assets') {
      this.currentWizardIndex += 1;
    }
  }
}
